import axios from 'axios';

export async function requestExportProgress(url, body, onProgress) {
  let offset = 0;
  let result;
  const consume = text => {
    if (typeof text !== 'string') return;
    let end;
    while ((end = text.indexOf('\n', offset)) !== -1) {
      const line = text.slice(offset, end);
      offset = end + 1;
      if (!line.trim()) continue;
      const event = JSON.parse(line);
      if (event.stage === 'heartbeat') continue;
      onProgress?.(event);
      if (event.stage === 'completed' || event.stage === 'failed') result = event;
    }
  };
  const response = await axios.post(url, body, {
    adapter: 'xhr', responseType: 'text', timeout: 0,
    onDownloadProgress: progress => consume(progress.event?.target?.responseText)
  });
  // The last chunk may arrive after the last browser progress notification.
  consume(response.data);
  if (!result) throw new Error('Le suivi de l’export a été interrompu. Vérifiez le résultat avant de relancer.');
  return result;
};

